// Auto-generated from button.spec.js
export default {
  "tagName": "ui-button",
  "content": [
    "icon",
    "image",
    "badge"
  ],
  "contentAttributes": [
    "icon",
    "image",
    "badge"
  ],
  "types": [
    "emphasis",
    "link",
    "styled",
    "toggle",
    "animated"
  ],
  "variations": [
    "floated",
    "fluid",
    "compact",
    "size",
    "circular",
    "attached",
    "type",
    "color",
    "social",
    "positive",
    "warning",
    "negative",
    "info",
    "transparent"
  ],
  "states": [
    "hover",
    "pressed",
    "focus",
    "active",
    "disabled",
    "loading"
  ],
  "settings": [
    "icon-only",
    "icon-after",
    "href"
  ],
  "attributes": [
    "icon",
    "image",
    "badge",
    "emphasis",
    "link",
    "styled",
    "toggle",
    "animated",
    "hover",
    "pressed",
    "focus",
    "active",
    "disabled",
    "loading",
    "floated",
    "fluid",
    "compact",
    "size",
    "circular",
    "attached",
    "type",
    "color",
    "social",
    "positive",
    "warning",
    "negative",
    "info",
    "transparent",
    "icon-only",
    "icon-after",
    "href"
  ],
  "optionAttributes": {
    "primary": "emphasis",
    "secondary": "emphasis",
    "subtle": "styled",
    "flat": "styled",
    "outline": "styled",
    "ghost": "styled",
    "disabled": "disabled",
    "left": "floated",
    "right": "floated",
    "compact": "compact",
    "mini": "size",
    "tiny": "size",
    "small": "size",
    "medium": "size",
    "large": "size",
    "big": "size",
    "huge": "size",
    "massive": "size",
    "top": "attached",
    "attached": "attached",
    "bottom": "attached",
    "submit": "type",
    "reset": "type",
    "red": "color",
    "orange": "color",
    "yellow": "color",
    "olive": "color",
    "green": "color",
    "teal": "color",
    "blue": "color",
    "violet": "color",
    "purple": "color",
    "pink": "color",
    "brown": "color",
    "grey": "color",
    "slate": "color",
    "instagram": "social",
    "facebook": "social",
    "twitter": "social",
    "linkedin": "social",
    "youtube": "social",
    "positive": "positive",
    "warning": "warning",
    "negative": "negative",
    "info": "info",
    "subtle-styled": "styled",
    "flat-styled": "styled",
    "outline-styled": "styled",
    "ghost-styled": "styled",
    "left-floated": "floated",
    "right-floated": "floated",
    "top-attached": "attached",
    "bottom-attached": "attached",
    "left-attached": "attached",
    "right-attached": "attached",
    "subtle-positive": "positive",
    "subtle-warning": "warning",
    "subtle-negative": "negative",
    "subtle-info": "info",
    "horizontal-animated": "animated",
    "vertical-animated": "animated",
    "fade-animated": "animated",
    "clickable-disabled": "disabled",
    "very-compact": "compact"
  },
  "propertyTypes": {
    "icon": "string",
    "image": "string",
    "badge": "string",
    "emphasis": "string",
    "link": "boolean",
    "styled": "string",
    "toggle": "boolean",
    "animated": "string",
    "hover": "boolean",
    "pressed": "boolean",
    "focus": "boolean",
    "active": "boolean",
    "disabled": "string",
    "loading": "boolean",
    "floated": "string",
    "fluid": "boolean",
    "compact": "string",
    "size": "string",
    "circular": "boolean",
    "attached": "string",
    "type": "string",
    "color": "string",
    "social": "string",
    "positive": "string",
    "warning": "string",
    "negative": "string",
    "info": "string",
    "transparent": "boolean",
    "icon-only": "boolean",
    "icon-after": "boolean",
    "href": "string"
  },
  "allowedValues": {
    "emphasis": [
      "primary",
      "secondary"
    ],
    "styled": [
      "subtle",
      "flat",
      "outline",
      "ghost"
    ],
    "animated": [
      "horizontal",
      "vertical",
      "fade"
    ],
    "disabled": [
      "disabled",
      "clickable"
    ],
    "floated": [
      "left",
      "right"
    ],
    "compact": [
      "compact",
      "very"
    ],
    "size": [
      "mini",
      "tiny",
      "small",
      "medium",
      "large",
      "big",
      "huge",
      "massive"
    ],
    "attached": [
      "top",
      "attached",
      "bottom",
      "left",
      "right"
    ],
    "type": [
      "submit",
      "reset"
    ],
    "color": [
      "red",
      "orange",
      "yellow",
      "olive",
      "green",
      "teal",
      "blue",
      "violet",
      "purple",
      "pink",
      "brown",
      "grey",
      "slate"
    ],
    "social": [
      "instagram",
      "facebook",
      "twitter",
      "linkedin",
      "youtube"
    ],
    "positive": [
      "positive",
      "subtle"
    ],
    "warning": [
      "warning",
      "subtle"
    ],
    "negative": [
      "negative",
      "subtle"
    ],
    "info": [
      "info",
      "subtle"
    ]
  },
  "attributeClasses": [
    "icon",
    "emphasis",
    "styled",
    "animated",
    "disabled",
    "attached",
    "color",
    "social"
  ],
  "defaultValues": {
    "icon-only": false,
    "icon-after": false,
    "href": ""
  },
  "inheritedPluralVariations": [
    "size",
    "floated",
    "compact",
    "color",
    "styled",
    "attached"
  ]
};
